<template>
  <Dialog :open="show" @update:open="onDialogUpdate">
    <DialogScrollContent>
      <DialogHeader>
        <DialogTitle>
          {{ $t('Slot setting') }}
        </DialogTitle>
      </DialogHeader>
      <div class="bg-light p-3">
        <small v-if="stage">
          {{ selectedStageInfo }}
        </small>
      </div>

      <div v-if="stage" class="mt-4">
        <h5>{{ $t('slot information') }}</h5>
        <DateRange
          :minDate="stage.start_at"
          :maxDate="stage.end_at"
          :zone="zone"
          :start-date="slot && slot.start_at ? slot.start_at : stage.start_at"
          :end-date="slot && slot.end_at ? slot.end_at : ''"
          @range-change="updateDateRange($event)"
        ></DateRange>

        <!--
        <div class="form-group">
            <div class="form-check">
                <input class="form-check-input" v-model="isRecurrent" type="checkbox" value="1" id="slot-recurrence">
                <label class="form-check-label" for="slot-recurrence">
                    Recurrence
                </label>
            </div>
        </div>
        <div v-if="isRecurrent && slot">
            <div class="form-group">
                <label for="slot-frequency">frequency</label>
                <select id="slot-frequency" v-model="slot.recurrence.freq" class="form-control">
                    <option value="MONTHLY">MONTHLY</option>
                    <option value="WEEKLY">WEEKLY</option>
                    <option value="DAILY">DAILY</option>
                </select>
            </div>

            <div class="form-group" v-if="slot.recurrence.freq === 'DAILY'">
                <div class="form-check form-check-inline" v-for="day in daysOfWeek" :key="day.v">
                    <input class="form-check-input" type="checkbox" v-model="slot.recurrence.byday" :value="day.v">
                    <label class="form-check-label">{{day.name}}</label>
                </div>
            </div>

            <div class="form-group">
                <label for="">End of recurrence</label>
                <datetime v-model="slot.recurrence.until" :min-datetime="stage.start_at" :max-datetime="stage.end_at"
                          :minute-step="15" value-zone="UTC" :zone="zone" type="datetime" auto inputClass="form-control"></datetime>
            </div>
        </div>
        -->
      </div>

      <Alert variant="danger" v-if="conflicts.length > 0 && slot.start_at && slot.end_at">
        <strong class="">{{ $t('Configuration conflict!') }}</strong>
        <hr>
        <p v-for="conflict in conflicts">
          {{ dayjs(conflict.start_at).format('LLL') + ' -> '  + dayjs(conflict.end_at).format('LLL') }}
        </p>
      </Alert>
      <DialogFooter>
        <button type="button" class="btn btn-primary" :disabled="!validForSave" v-on:click="saveSlot()">
          {{ $t('Save') }}
        </button>
      </DialogFooter>
    </DialogScrollContent>
  </Dialog>
</template>

<script>
    import dayjs from "dayjs";
    import DateRange from '../DateRange.vue'
    import { Dialog, DialogScrollContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
    import Alert from "@/components/ui/Alert.vue";
    export default {
        name: "modal",
        components: {
          Alert,
          DialogFooter,
          DialogTitle,
          DialogHeader,
          DialogScrollContent,
          Dialog,
          DateRange,
        },
        props: {
            show: {
                default : false,
            },
            zone: {
                default: 'UTC'
            },
            stage: {
                type: Object
            },
            slotConfig: {
                type: Object,
                default : null,
            },
        },
        data() {
            return {
                slot: {
                    stage: null,
                    start_at: null,
                    end_at: null,
                    id: null,
                    recurrence: {
                        freq: null,
                        byday: [],
                        until : null,
                    },
                },
                isRecurrent: false,
                daysOfWeek : [
                    { v: 'MO' , name : 'MO'},
                    { v: 'TU' , name : 'TU'},
                    { v: 'WE' , name : 'WE'},
                    { v: 'TH' , name : 'TH'},
                    { v: 'FR' , name : 'FR'},
                    { v: 'SA' , name : 'SA'},
                    { v: 'SU' , name : 'SU'},
                ],
            }
        },
        computed: {
          dayjs() {
            return dayjs
          },
            validForSave() {
                return !!(this.stage && this.slot.start_at &&  this.slot.end_at && (this.conflicts.length === 0))
            },
            selectedStageInfo() {
                return dayjs(this.stage.start_at).format('LLL') + ' -> '  + dayjs(this.stage.end_at).format('LLL');
            },
            conflicts() {
              return this.stage.booking_slots.filter((slot) => {
                if (slot.id === this.slot.id) {
                  return false;
                }
                return dayjs(slot.start_at) < dayjs(this.slot.end_at) && dayjs(slot.end_at) > dayjs(this.slot.start_at);
              });
            },
        },
        methods: {
            updateDateRange(e) {
                this.$emit('updateDateRange', e)
                this.slot.start_at = e.start;
                this.slot.end_at = e.end;
            },
            saveSlot() {
                this.slot = {
                  ... this.slot,
                  stage: this.stage.id,
                }
                this.$emit('save-slot', this.slot)
            },
            onDialogUpdate(isOpen) {
              if (!isOpen) {
                this.$emit('close')
              }
            },
        },
        watch: {
            slotConfig (value) {
                console.log('slotConfig change', value);
                if(value) {
                  this.slot = {
                    stage: null,
                    start_at: null,
                    end_at: null,
                    ...value,
                  }
                }
            },
            stage (value) {
              this.slot = {
                stage: value.id,
                start_at: null,
                end_at: null,
                recurrence: {
                  freq: null,
                  byday: [],
                  until : null,
                },
                ...this.slotConfig,
              };
            },
        },
        created() {
            if (this.slotConfig) {
                this.slot = {
                  ...this.slot,
                  ...this.slotConfig
                }
            }

            if (this.slotConfig && this.slotConfig.recurrence) {
                this.isRecurrent = true;
                var recurrence = this.slotConfig.recurrence.split(";");
                // console.log(recurrence)
                var r = recurrence.reduce(function(accumulator, rule) {
                    // console.log(rule);
                    // FREQ=DAILY;UNTIL=20190401T220000;BYDAY=MO,SU,FR,TH,TU,WE,SA
                    var r = rule.split('=');
                    var key = r[0].toLowerCase();
                    var v = r[1];
                    if (key === 'byday') {
                        accumulator[key] = v.split(',');
                    } else if (key === 'until') {
                        // console.log('until', v);
                        accumulator[key] = v;
                    } else if (key === 'freq') {
                        accumulator[key] = v;
                    }
                    return accumulator;
                }, {});
                // console.log(r);
                this.slot.recurrence = r;
            }

        },
    }
</script>
